import { STATE } from "./names";

export default () => {
    return {
        [STATE.FULL_PAGE_LOADING_VISIBLE]: false,
        [STATE.FULL_PAGE_LOADING_TEXT]: '',
    };
};
